import { usePaldockTranslation } from "hooks/usePaldockTranslation.tsx";

export const useStatusSelectOptions = () => {
    const { t } = usePaldockTranslation("general.status");

    // Static options: enabled/disabled with translations
    const options = [
        { label: t("enabled"), value: true },
        { label: t("disabled"), value: false },
    ];

    return { options, loading: false, error: null };
};
